import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TimePicker } from 'antd/es';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';

const pickerStyles = {
  width: '100%',
};

const { Option } = Select;

const InfoSection = ({ shops, inactiveShops, facilityTypes, isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Insegna')} name='company_id'>
          <Select
            disabled={isView}
            placeholder={t('Insegna')}
            {...Helpers.addSearchProps()}
          >
            <Option value={''}>{t('Insegna')}</Option>
            {renderGroupedShopOptions({
              shops,
              inactiveShops,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Categoria richiesta')} name='facility_type'>
          <Select disabled={isView} placeholder={t('Categoria richiesta')}>
            <Select.Option value={''}>{t('Categoria richiesta')}</Select.Option>
            {Object.entries(facilityTypes).map((i) => (
              <Select.Option key={i[0]} value={i[0]}>
                {i[1]}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col offset={6} span={5}>
        <Form.Item label={t('Data dal')} name='date_from'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={pickerStyles}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label={t('Orario dalle')} name='time_from'>
          <TimePicker minuteStep={15} disabled={isView} format={'HH:mm'} style={pickerStyles} />
        </Form.Item>
      </Col>
      <Col span={5}>
        <Form.Item label={t('Data al')} name='date_to'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={pickerStyles}
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label={t('Orario alle')} name='time_to'>
          <TimePicker minuteStep={15} disabled={isView} format={'HH:mm'} style={pickerStyles} />
        </Form.Item>
      </Col>

      <Col offset={6} span={9}>
        <Form.Item label={t('Descrizione')} name='description'>
          <Input.TextArea
            disabled={isView}
            rows={6}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
